// The whole code is copied from VPC.

import { connect } from 'react-redux';
import { AppState } from '../../../../app/state/AppState';
import { selectMetricDataForContentItem } from '../../../selectors/selectMetrics';
import { MetricCard, MetricCardOwnProps } from './MetricCard';

const mapStateToProps = (state: AppState, ownProps: MetricCardOwnProps) => {
  return {
    metricData: selectMetricDataForContentItem(state, ownProps.content),
  };
};
export const ConnectedMetricCard: React.ComponentClass<MetricCardOwnProps> = connect(mapStateToProps, undefined)(MetricCard);
